<ng-container>
  @if ((combinedOrganizers$ | async)) {
    <table class="table marginTopTwentyPx">
      <thead>
        <tr>
          <th scope="col" (click)="sortOrganizers('name')" (keyup)="sortOrganizers('name')" class="sortable-heading">
            Name @if (sortColumn === 'name') {
            <img [src]="getSortIcon('name')" alt="Sort Icon">
          }
        </th>
        <th scope="col" (click)="sortOrganizers('role')" (keyup)="sortOrganizers('role')" class="sortable-heading">
          Role @if (sortColumn === 'role') {
          <img [src]="getSortIcon('role')" alt="Sort Icon">
        }
      </th>
      <th scope="col" (click)="sortOrganizers('email')" (keyup)="sortOrganizers('email')" class="sortable-heading">
        Email Address @if (sortColumn === 'email') {
        <img [src]="getSortIcon('email')" alt="Sort Icon">
      }
    </th>
    @if (showActions) {
      <th scope="col">Actions</th>
    }
  </tr>
</thead>
<tbody>
  @for (orderOrganizer of (combinedOrganizers$ | async); track orderOrganizer.id) {
    <tr data-cy="orderOrganizerRecord">
      <td [attr.data-cy]="'organizer-' + orderOrganizer.id"
        class="order-organizer-cell">
        <div ngbTooltip="{{ orderOrganizer | participantDisplayNameTooltip }}">
          {{ orderOrganizer | participantDisplayName }}
        </div>
      </td>
      <td class="order-organizer-cell">{{getFriendlyRole(orderOrganizer)}}</td>
      <td class="order-organizer-cell">{{orderOrganizer.email}}</td>
      @if (showActions) {
        <td class="order-organizer-cell">
          <action-dropdown-button (actionCalled)="handleActionCall($event)" [actions]="orderOrganizer.actions"></action-dropdown-button>
        </td>
      }
    </tr>
  }
</tbody>
</table>
} @else {
  <div class="jumbotron empty-jumbotron-message">
    <div class="d-flex justify-content-center align-items-center">
      <span class="jumbotron-heading">
        Loading Order Organizers
      </span>
      <span class="fas fa-spinner fa-spin primary-color-txt fa-2x ms-2"></span>
    </div>
    <app-skeleton-loading-list [rowCount]="2"
    [tableName]="'organizers'"></app-skeleton-loading-list>
  </div>
}
</ng-container>
